module.exports = __webpack_public_path__ + "static/hometown-mobile.cab3c4fa.webp";